export default "/images/reports-active-dark.svg?11d8dd048c13ae4d23c70f6e610a0a09";